export enum ProductKeysTab {
  fullDescription = 'fullDescription',
  garnish = 'garnish',
  energyValue = 'energyValue',
  ingredients = 'ingredients',
}
